import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IAdminNotification } from '../../../../../../../common/common-interfaces/admin-notification';
import { Api } from '../../../services/api';
import { Globals } from '../../../services/globals';
import { Utility } from 'src/app/services/utility';
import { NgZone } from '@angular/core';

@Component({
    selector: 'admin-notifications',
    templateUrl: './admin-notifications.component.html',
    styleUrls: ['./admin-notifications.component.scss'],
    standalone: false
})
export class AdminNotificationsComponent {
  hideMenu: boolean;
  adminNotifications: IAdminNotification[] = [];
  constructor(private api: Api, private router: Router, private route: ActivatedRoute, public globals: Globals, public utility: Utility, private zone: NgZone) {

  }

  async ngOnInit() {

    if (window.location.hash.includes('hideMenu')) {
      (document.querySelector('.menu') as any).style.display = 'none';
      this.hideMenu = true;
    }

    setInterval(() => {
      this.zone.run(async () => {
        await this.fetchNotifications();
      });
    }, 1000 * 60 * 10);

    await this.fetchNotifications();
  }


  async acknowledge(notification) {
    await this.api.admin().post<any>(`/admin-notifications/${notification._id}/acknowledge`, {});
    notification.acknowledge = {
      date: new Date()
    };
  }

  async fetchNotifications(){
    this.adminNotifications =  await this.api.admin().get<any>(`/admin-notifications/latest`);
  }





}
